enum DeviceTypeEnum {
  SITE_CONTROLLER = 'siteController',
  UNIT_CONTROLLER = 'unitController',
  PCS = 'pcs',
  CONVERTER = 'converter',
  MODULE = 'module',
  BMS = 'bms',
  RACK = 'rack',
  TSC = 'tsc',
  RTAC = 'rtac',
  METER_POINT = 'mp',
  METER = 'meter',
  SITE = 'site',
  UNIT = 'unit',
  TRACKER = 'tracker',
  MASTER_TRACKER = 'master_tracker',
  MET = 'met',
  MET_SITE = 'met_site',
  POWIN_EMS = 'powinems',
  POWIN_BESS = 'powinbess',
  POWIN_RACK = 'powinrack',
}

export const DeviceType = DeviceTypeEnum;

export type DeviceType = `${DeviceTypeEnum}` | (string & {});
